import { FC, useCallback, useState } from 'react';
import Link from 'next/link';
import Button from 'src/common/components/Button';
import { PATHS } from 'src/common/constants';
import { useUserContext } from 'src/common/providers/UserProvider';
import styles from './AcceptPanel.module.scss';

const AcceptPanel: FC = () => {
  const { user, patchUser } = useUserContext();
  const [submitting, setSubmitting] = useState(false);
  const agreeToTerms = useCallback(async () => {
    setSubmitting(true);
    await patchUser({ terms_agreed: true });
  }, [patchUser]);

  if (!user?.id || user?.terms_agreed) {
    return null;
  }

  return (
    <>
      <div className={styles.spacer} />
      <div className={styles.panel}>
        <div className={styles.content}>
          <p>
            {'Choosing “I Agree” means you understand and agree to Getmyboat’s '}
            <Link href={PATHS.TERMS} className={styles.link}>
              Terms of Use
            </Link>
            {', '}
            <Link href={PATHS.MEMBER_INTERFACE} className={styles.link}>
              Member Interface Agreement
            </Link>
            {' and '}
            <Link href={PATHS.PRIVACY_POLICY} className={styles.link}>
              Privacy Policy
            </Link>
            .
          </p>
          <Button
            type="button"
            classNameModifier="accept"
            onClick={agreeToTerms}
            submitting={submitting}
          >
            I Agree
          </Button>
        </div>
      </div>
    </>
  );
};

export default AcceptPanel;
